import Ordine from "./Ordine";

export default class Cliente {
    documentId: string;
    authorized: boolean;
    codiceTavolo: string;
    connesso: number;
    data: Date;
    idRistorante: string;
    idUtente: string;
    nClienti: number;
    nCopertiPagati: number;
    pagato: number;
    recensione: boolean;
    ordini: Ordine[];

    constructor() {
        this.documentId = "";
        this.authorized = false;
        this.codiceTavolo = "";
        this.connesso = 0;
        this.data = new Date();
        this.idRistorante = "";
        this.idUtente = "";
        this.nClienti = 0;
        this.nCopertiPagati = 0;
        this.pagato = 0;
        this.recensione = false;
        this.ordini = [];
    }

    getFormattedDateTime(): string {
        let options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' };
        return this.data.toLocaleDateString("it-IT", options)
    }
}